export enum ElementType {
	Question = 1,
	PageBreak = 2,
	SectionBreak = 4,
	SectionHeader = 5,
	TextElement = 6,
}
